module.exports = __webpack_public_path__ + "fonts/iconfont.5832dc0a.woff2";